import type { Clip } from './types'

export function clipMatchesQuery(clip: Pick<Clip, 'title' | 'speaker' | 'rationale' | 'hook'>, query: string) {
  const needle = query.trim().toLocaleLowerCase()
  if (!needle) return true
  return `${clip.title} ${clip.speaker || ''} ${clip.rationale || ''} ${clip.hook || ''}`.toLocaleLowerCase().includes(needle)
}
